<template>
  <div class="greeting_wrapper">
    <p v-if="getUserType === 'observer'" class="greeting_name">Good {{ getMessage }}, {{ getName }}.</p>
    <template v-else>
      <button :class="['import-button', hasBeenTwoWeeks ? 'import-button-highlight' : '']" @click="$router.push({ path: '/import' })">
        <img v-if="hasBeenTwoWeeks" src="./icons/importHighlight.svg" /> 
        <img v-else src="./icons/import.svg" /> 
        Start New Import
      </button>
      <p class="import-text">Last import was done on {{ }}</p>
    </template>
    <div class="right_filter">
      <p class="filter_text">{{ getUserType === 'observer' ? 'Filter data by' : 'Filter' }}</p>
      <el-select
        v-model="value"
        placeholder="All Sites"
        class="dropdown"
        @change="handleSiteChange"
      >
        <el-option
          v-for="item in getOptionsValues"
          :key="item.value"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import { getGreeting } from "../util/date-range.js";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      value: null,
      hasBeenTwoWeeks: false
    };
  },
  computed: {
    ...mapGetters("user", ["getName"]),
    ...mapGetters("overview", ["allSites"]),
    ...mapGetters(["getUserType"]),
    getMessage() {
      return getGreeting(DateTime.now().toFormat("HH"));
    },
    getOptionsValues() {
      return [
        {
          id: null,
          name: "All Sites",
        },
        ...this.allSites,
      ];
    },
  },
  methods: {
    ...mapActions("overview", ["changeActiveProvider"]),
    handleSiteChange(data) {
      this.changeActiveProvider(data);
    },
  },
};
</script>

<style scoped>
.greeting_wrapper {
  display: flex;
  height: 45px;
  background-color: #fff;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
}

.greeting_name {
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
  color: #333333;
}

.filter_text {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #333333;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.right_filter {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.dropdown {
  font-size: 14px;
  width: 180px;
  padding: 0.5rem;
  outline: none;
}
.import-button {
  border: 1px solid #E87318;
  border-radius: 2px;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #E87318;
  padding: 7px 14px;
  background-color: #ffffff;
}
.import-button-highlight {
  background-color: #E87318;
  color: #ffffff;
}
.import-button img {
  padding: 2px 5px 0 0;
}
.import-text {
  position: absolute;
  left: 185px;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #666666;
}
</style>
